export default __webpack_public_path__ + "static/media/loading-2.0b9fce1a.jpeg";